import { Grid, Image } from 'antd';

const { useBreakpoint } = Grid;

const ResponsiveBanner = () => {
  const screens = useBreakpoint();

  return (
    <Image
      preview={false}
      alt="Terraformando | Construindo nuvens com código"
      width="100%"
      src={
        screens.xs
          ? '/images/banner-mobile.png'
          : '/images/banner-desktop.png'
      }
      style={{
        borderBottom: '1px solid #f3f3f3',
        display: 'block',
        margin: '0 auto',
        maxWidth: screens.xs ? '100%' : '1220px', // ajuste conforme necessidade
        objectFit: 'cover',
      }}
    />
  );
};

export default ResponsiveBanner;